module.exports = __webpack_public_path__ + "static/media/icon-bgDownArrow.4db1d1a7.svg";